function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAllMatchesFilterIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none"
    },
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.156 4.306h7.518a1.052 1.052 0 0 0-1.193-1.049h-5.139a1.042 1.042 0 0 0-1.186 1.049zM7.849 6.51h10.125a1.158 1.158 0 0 0-1.285-1.133H9.133A1.158 1.158 0 0 0 7.849 6.51zm.813 14.747H17.4a2.156 2.156 0 0 0 2.3-2.47v-8.6a2.21 2.21 0 0 0-2.493-2.47H8.662a2.21 2.21 0 0 0-2.493 2.47v8.6a2.21 2.21 0 0 0 2.493 2.47zm1.855-4.789a3.176 3.176 0 0 0-2.858 1.612v-7.769a.979.979 0 0 1 1.095-1.1h8.369a.982.982 0 0 1 1.095 1.1v7.427a3.692 3.692 0 0 0-2.888-1.254c-2.159 0-3.519 1.535-3.519 2.744a.976.976 0 0 0 .129.54h-.95a1.849 1.849 0 0 1-.076-.555 3.244 3.244 0 0 1 1.14-2.372 2.962 2.962 0 0 0-1.537-.373zm4.812-.867A1.76 1.76 0 0 0 17 13.754a1.726 1.726 0 0 0-1.672-1.794 1.751 1.751 0 0 0-1.68 1.809 1.772 1.772 0 0 0 1.681 1.831zm-4.812.1a1.537 1.537 0 0 0 1.459-1.612 1.463 1.463 0 1 0-2.919.008 1.535 1.535 0 0 0 1.46 1.603z",
    transform: "translate(-.938 -.257)",
    style: {
      fill: "currentColor"
    }
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAllMatchesFilterIcon);
export default __webpack_public_path__ + "static/media/all-matches-filter-icon.0c172184.svg";
export { ForwardRef as ReactComponent };